// extracted by mini-css-extract-plugin
module.exports = {"ZIComp":"ZI_ZIComp__RHE4S"};